import React, { useEffect, useRef, useState } from "react";
import ServicePrism from "./ServicePrism";
import "../../styles/home.css";

// Staggers each revealed element by its order in the section.
const delay = (i) => ({ transitionDelay: `${i * 0.12}s` });

// Opens a service in the Our Services section below.
const showService = (i) => {
  window.dispatchEvent(new CustomEvent("our-services:show", { detail: i }));
  document.getElementById("our-services")?.scrollIntoView({ behavior: "smooth" });
};

// Intro copy, plus the service prism; picking a service opens it in Our Services.
const WhatWeDo = () => {
  const sectionRef = useRef(null);
  const [revealed, setRevealed] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        setRevealed(true);
        observer.disconnect();
      },
      { threshold: 0.15 }
    );
    observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="what-we-do" className={`home_sec3 ${revealed ? "is-revealed" : ""}`} ref={sectionRef}>
      <div className="container position-relative">
        <div className="wwd-grid">
          <div className="higlighted_words">
            <div className="title-wrapper wwd-reveal" style={delay(0)}>
              <h2 className="what-we-do-title text-uppercase fw-bold mb-4">
                What We <span className="accent-red">Do</span>
              </h2>
            </div>
            <p
              className="fs-6 text-gray-300 lh-lg mb-0 wwd-reveal"
              style={{ fontWeight: 400, ...delay(1) }}
            >
              We blend strategy, creativity, production and culture to create work that moves people.
              From immersive experiences and talent-led campaigns to premium content powered by
              creativity and AI, we bring together the right ideas, people and production to help
              brands inspire, engage and make an impact.
            </p>
            <p className="wwd-tagline wwd-reveal" style={delay(2)}>
              Because attention fades. Unforgettable brands don't.
            </p>
          </div>

          <ServicePrism onOpen={showService} className="wwd-reveal" style={delay(2)} />
        </div>
      </div>
    </section>
  );
};

export default WhatWeDo;
